<template>
  <div class="covid-search-results">
    <h2 class="results-label">
      {{title}}
    </h2>
    <p id="msgResultCards" class="nb-results-sentence" aria-live="polite">
      <span class="nb-results">{{ count }} résultats</span> trouvés
    </p>
    <div class="sort-by-distance">
      <div class="box-checkbox checkbox-item">
        <input type="checkbox" id="cbid" v-model="filterDistanceChecked"  value="" aria-describedby="sort-by-distance__text">
        <label for="cbid">Trier les résultats par distance</label>
      </div>
      <p id="sort-by-distance__text">(Nous utilisons votre position géolocalisée pour nos calculs de distance)</p>
    </div>
    <ul v-if="count" class="resetul covid-search-cards-list">
      <template
        v-for="(centerInfo, index) in screeningCentersResults"
        :key="centerInfo.getNodeId().toString() + index.toString()">
        <BoxInfo
          v-show="centerInfo.show"
          :box-info="centerInfo"
          :page-origin="origin"
        />
      </template>
    </ul>
  </div>
</template>

<script>
import { watch, ref } from 'vue';
import BoxInfo from '@/components/sharedComponents/BoxInfo.component.vue';

export default {
  components: {
    BoxInfo,
  },
  emits: ['onCheckFilterDistance'],
  props: {
    count: {
      type: Number,
      default: 0,
    },
    screeningCentersResults: {
      type: Array,
      default: () => [],
    },
    region: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    origin: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const filterDistanceChecked = ref(false);
    watch(filterDistanceChecked, (value) => {
      emit('onCheckFilterDistance', value);
    });
    return {
      filterDistanceChecked,
    };
  },
};
</script>
